<template>
    <div class="tab-header" v-if="dictionaries.orderTypes.length && !loading" ref="div">
        <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage" 
        :enforce-focus="true">
<h3>{{ $t('views.order.view.tabs.label.loading') }}</h3>
</loading>
        <md-tabs style="overflow-x: auto;" md-alignment="left" class="md-tab-content-page" 
        md-sync-route ref="tabs">
            <md-tab :md-label="$t('views.order.view.tabs.label.common')" class="md-layout md-alignment-center-center"
                    id="campaignForm" :to="`/campaign/${campaign.common.id || actionOrId}`" exact>
                <campaign-form class="md-layout-item" v-model="campaign.common" ref="campaignForm"
                               @validChange="isCommonDataValid = $event"
                               @dirtyChange="isCommonDataDirty = $event"
                               :orders-count="ordersCount" /> 
            </md-tab>
            <md-tab v-for="(order, index) in campaign.orders"
                    :key="`${order.orderType.shortName}${order.no}`"
                    :id="`order-${order.no}`"
                    :md-label="$t(`views.order.view.tabs.label.${order.orderType.shortName}`, {n: index + 1})"
                    :to="`/campaign/${actionOrId}/order/${order.id || (`new-${order.orderType.shortName}-${order.no}`)}`" exact
                    class="md-layout md-alignment-left">
                <component :disabled="isLoading" :is="`order-${order.orderType.shortName.toLowerCase()}-form`"
                           :value="order"
                           @input="setData($event)"
                           :common="campaign.common"
                           @cancel="removeOrderTab(order.orderType.shortName, order.no)"
                           :order-no="order.no"
                           :dictionaries="dictionaries"
                           ref="order"
                           :key="order.no"
                           class="md-layout-item" />
            </md-tab>
            <md-tab id="campaignSummary" :md-label="$t('views.order.view.tabs.label.summary')"
                    :to="`/campaign/${actionOrId}/summary`" :md-disabled="!campaign.orders.length || checkOrderId()"
                    class="md-layout md-alignment-center-left" :key="ordersCount + 1">
                <campaign-summary :orders="campaign.orders"
                                  :common="campaign.common"
                                  class="md-layout-item" />
            </md-tab>
        </md-tabs>
        <md-menu md-align-trigger md-size="medium" class="md-ml-30">
            <md-tooltip md-direction="left" v-show="!isCommonDataValid">{{ $t('views.order.view.add.commonDataAreInvalid') }}</md-tooltip>
            <md-button class="md-header-btn" md-menu-trigger :disabled="!isCommonDataValid">
                {{ $t('views.order.view.add.title') }}
            </md-button>

            <md-menu-content>
                <md-menu-item v-if="checkUserPrivilages('tv')" @click.prevent="createOrder('TV')">{{ $t('views.order.view.add.tv') }}</md-menu-item>
                <md-menu-item v-if="checkUserPrivilages('internet')" @click.prevent="createOrder('Internet')">{{ $t('views.order.view.add.internet') }}</md-menu-item>
                <md-menu-item v-if="checkUserPrivilages('radio') && showMediumRadio" @click.prevent="createOrder('Radio')">{{ $t('views.order.view.add.radio') }}</md-menu-item>
                <md-menu-item v-if="checkUserPrivilages('ooh')" @click.prevent="createOrder('OOH')">{{ $t('views.order.view.add.ooh') }}</md-menu-item>
                <md-menu-item v-if="checkUserPrivilages('da')" @click.prevent="createOrder('DA')">{{ $t('views.order.view.add.da') }}</md-menu-item>
            </md-menu-content>
        </md-menu>
</div>
</template>

<script>
import CampaignSummary from '@/views/order/CampaingSummary';
import CampaignForm from '@/views/order/CampaignForm';
import OrderTvForm from '@/views/order/OrderTvForm';
import OrderRadioForm from '@/views/order/OrderRadioForm';
import OrderInternetForm from '@/views/order/OrderInternetForm';
import OrderOohForm from '@/views/order/OrderOohForm';
import OrderDaForm from '@/views/order/OrderDaForm';
import {campaignsEndpoint, dictionariesEndpoint} from '@/services/adsign-backend/endpoints';
import {checkPrivilagesForOrder} from '@/utils/jwtUtils'
 import { mapGetters } from "vuex";
 import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'CampaignView',
    components: {CampaignForm, CampaignSummary, OrderTvForm, OrderRadioForm, OrderInternetForm, OrderOohForm, OrderDaForm, Loading},
    props: {
        actionOrId: {
            type: String,
            required: true
        },
        orderId: {
          type: [Number,String],
          default: undefined
        }
    },
    computed: {
        ordersCount: {
            get() {
                return this.campaign.orders.length;
            }
        },
            ...mapGetters("auth", ["getMediumsForUserPrivilages"]),
            ...mapGetters('misc', ["agencyId"])
    },
    data: () => ({
        isLoading: false,
        fullPage: true,
        isAdmin: false,
        activeTab: undefined,
        loading: true,
        sending: false,
        mediumId: [],
        campaign: {
            common: {},
            orders: []
        },
        dictionaries: {
            spotTypes: [],
            sponsorshipTypes: [],
            priceMethods: [
                {
                    name: 'grp',
                    unit: 'GRP'
                },
                {
                    name: 'budget',
                    unit: 'PLN'
                }
            ],
            grpSaleTypes: [],
            packageTypes: [],
            targetGroups: [],
            orderTypes: []
        },
        lastOrderNo: 0,
        isCommonDataValid: false,
        isCommonDataDirty: false,
        showMediumRadio: false
    }),
    methods: {
        setData(orderData) {
            const index = this.campaign.orders.findIndex(order => order.no == orderData.no);
            if (index >= 0) {
                this.$set(this.campaign.orders, index, orderData);
                if (orderData.id && this.$route.path.toLowerCase().includes('/order/new-')) {
                    this.$router.push(`/campaign/${this.actionOrId}/order/${orderData.id}`);
                }
            }
        },

      loadDictionaries() {
        dictionariesEndpoint.getDictionary('grp_sale_type').then(result => this.dictionaries.grpSaleTypes = result.data);
        dictionariesEndpoint.getDictionary('order_type').then(result => this.dictionaries.orderTypes = result.data);
        dictionariesEndpoint.getDictionary('spot_type').then(result => this.dictionaries.spotTypes = result.data);
        dictionariesEndpoint.getDictionary('package_type').then(result => this.dictionaries.packageTypes = result.data);
      },

        createOrder(orderType) {
            if(this.sending === true){
                return
            }

            this.sending = true

            const newOrder = {
                no: ++this.lastOrderNo,
                orderType: {
                  shortName: orderType,
                }, 
                orderTypeId: this.getOrderTypeValueIdByShortname(orderType),
                orderProducts: [],
                orderStations: [],
                orderProductsSequences: [],
                orderAttachments: []
            };
            this.storeCampaignData().then(() => {
                this.campaign.orders.push(newOrder);
                this.$router.push(`/campaign/${this.actionOrId}/order/new-${orderType}-${this.lastOrderNo}`);
                setTimeout(() => {
                    this.sending = false;
                }, 1000)
            })
        },

        getOrderTypeValueIdByShortname(shortName) {
            return this.dictionaries.orderTypes.find(item => item.shortName.toLowerCase() === shortName.toLowerCase())?.valueId;
        },

        removeOrderTab(orderType, orderNo) {
            const index = this.campaign.orders.findIndex((order) => order.no == orderNo && order.orderType.shortName == orderType);
            if (index >= 0) {
                this.campaign.orders.splice(index, 1);
                this.$router.push(`/campaign/${this.actionOrId}`);
            }
        },

        storeCampaignData() {
            return this.$refs.campaignForm.sync();
        },

        async checkAvailableMedia(){
            return this.getMediumsForUserPrivilages(this.agencyId, "PRIVILEGE_ORDER_CREATE");
        },

        checkUserPrivilages(shortName){
            const mediumsId = this.dictionaries.orderTypes.find(item => item.shortName.toLowerCase() === shortName.toLowerCase())?.id
            if(this.isAdmin)
                return true
            if(this.mediumId.find(item => item === mediumsId))
                return true
        },

        checkOrderId() {
          if(+this.orderId){
            return false
          }
          return true
        },
        doAjax() {
            if (this.campaign.orders.length > 10){
                this.isLoading = true
                setTimeout(() => {
                    this.isLoading = false
                }, 6500)
            } else {
                this.isLoading = false
            }
        },
    },
    created() {
        if (this.actionOrId != 'create' && this.actionOrId != 'continue') {
            campaignsEndpoint.getCampaign(this.actionOrId).then(result => {
                this.campaign = {
                    common: {
                        id: this.actionOrId,
                        name: result.data.name,
                        agencyId: result.data.agency.id,
                        clientId: result.data.client.id,
                        validFrom: this.$moment(result.data.validFrom).format('L'),
                        validTo: this.$moment(result.data.validTo).format('L'),
                        description: result.data.description
                    },
                    orders: result.data.orders.map((order, index) => ({
                        id: order.id,
                        no: index + 1,
                        loadData: true,
                        orderType: {
                          shortName: order.orderType.name,
                        },
                        orderTypeId: order.orderType.valueId,
                        orderProducts: [],
                        orderStations: [],
                        orderProductsSequences: [],
                        orderAttachments: []
                    }))
                }
            }).then(() => {
                this.lastOrderNo = this.campaign.orders.reduce((prev, current) => prev.no > current.no ? prev.no : current.no, this.lastOrderNo);
            }).finally(() => {
                this.loading = false;
                this.doAjax();
            });
        } else {
            this.loading = false;
        }
    },

    mounted() {
        this.$watch(() => this.campaign.common.id, (newId) => {
            if (this.$route.path.toLowerCase().startsWith('/campaign/create')) {
                this.$router.push(this.$route.path.toLowerCase().replace('/campaign/create', `/campaign/${newId}`));
            }
        })
        this.loadDictionaries();
        this.lastOrderNo = this.campaign.orders.reduce((prev, current) => prev.no > current.no ? prev.no : current.no, this.lastOrderNo);
        this.$watch(() => this.checkAvailableMedia().then(result => {
            if(result === -1)
                this.isAdmin = true
            else
                this.mediumId = result
        }))
    }
}
</script>

<style scoped lang="scss">
    .md-tab {
        flex-basis: 100%;
        flex-shrink: 0;
    }

    .tab-header {
        display: flex;
    }
</style>
